import { render, staticRenderFns } from "./ApplyTaste.vue?vue&type=template&id=b5144792&scoped=true&"
import script from "./ApplyTaste.vue?vue&type=script&lang=js&"
export * from "./ApplyTaste.vue?vue&type=script&lang=js&"
import style0 from "./ApplyTaste.vue?vue&type=style&index=0&id=b5144792&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5144792",
  null
  
)

export default component.exports